/** Canonical office_url: "https://feu.com.ua/" → "feu.com.ua". Used in UI and API. */
export const toOfficeUrl = (url: string | null | undefined): string => {
  const trimmed = String(url ?? "").trim();
  if (!trimmed) return "";

  try {
    const withProtocol = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    return new URL(withProtocol).hostname.replace(/^www\./i, "");
  } catch {
    return trimmed
      .replace(/^https?:\/\//i, "")
      .replace(/^www\./i, "")
      .replace(/\/.*$/, "");
  }
};

/** Ukraine FEU office — special admission letter backgrounds / API. */
export const FEU_UA_OFFICE_URL = "feu.com.ua";

export const isFeuComUaOffice = (url: string | null | undefined): boolean => {
  return toOfficeUrl(url) === FEU_UA_OFFICE_URL;
};

export const formatOfficeUrlForDisplay = toOfficeUrl;

/** Domain for API payloads. Empty / missing → null (omit or clear). */
export const toOfficeUrlForApi = (url: string | null | undefined): string | null => {
  if (url == null) return null;
  return toOfficeUrl(url) || null;
};

/** Query/body fragment for list filters. Empty site selection is omitted. */
export const withOfficeUrlQuery = (officeUrl?: string | null): { office_url: string } | Record<string, never> => {
  const canonical = toOfficeUrl(officeUrl);
  return canonical ? { office_url: canonical } : {};
};

export const officeUrlsMatch = (left: string | null | undefined, right: string | null | undefined): boolean => {
  const a = toOfficeUrl(left);
  const b = toOfficeUrl(right);
  return Boolean(a) && a === b;
};
